import { prefixObjectValues } from '../utils';

const profile = {
  layout: 'layout',
  name: 'name',
  desc: 'description',
  verification: 'certification',
  npiNum: 'npiNum',
};

export default prefixObjectValues(profile, 'dashboard-profile-');
